import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Extraction } from '@modules/extractions/extraction.interface';
import { ExtractionsService } from '@modules/extractions/extractions.service';
import { MenuItem, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { EntityViewerComponent } from '../entity-viewer/entity-viewer.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ActionsService } from '@modules/search/services/actions.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';

import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-extraction-detail',
  standalone: true,
  imports: [
    ButtonModule,
    EntityViewerComponent,
    SvgIconComponent,
    CommonModule,
    FormsModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    MenuModule,
  ],
  templateUrl: './extraction-detail.component.html',
  styleUrl: './extraction-detail.component.scss',
})
export class ExtractionDetailComponent implements OnInit, OnChanges {
  @Input() extraction: Extraction = {} as Extraction;
  @Input() maxHeight: string = 'calc(100vh - var(--topNav-height))';
  @Input() close: any = () => {};

  searchQuery: string = '';
  filteredEntries: any = this.extraction.entities || [];

  constructor(
    protected _extraction: ExtractionsService,
    private _action: ActionsService,
    protected messageService: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.filteredEntries = this.extraction.entities || [];
    this.searchQuery = '';
  }
  ngOnInit(): void {
    this.filteredEntries = this.extraction.entities || [];
  }

  filterEntries() {
    if (this.searchQuery.trim() === '') {
      this.filteredEntries = this.extraction.entities;
      return;
    }

    if (this.extraction && this.extraction.entities) {
      const filteredEntities: any = {};

      const traverseAndFilter = (obj: any, parentKey: string = ''): any => {
        const result: any = {};
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const keyMatch = key
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase());

            if (typeof value === 'object' && value !== null) {
              const nestedFiltered = traverseAndFilter(value, key);
              if (Object.keys(nestedFiltered).length > 0 || keyMatch) {
                result[key] = nestedFiltered;
              }
            } else if (
              keyMatch ||
              (value &&
                value
                  .toString()
                  .toLowerCase()
                  .includes(this.searchQuery.toLowerCase()))
            ) {
              result[key] = value;
            }
          }
        }
        return result;
      };

      this.filteredEntries = traverseAndFilter(this.extraction.entities);
    } else {
      this.filteredEntries = {};
    }
  }

  clearSearch() {
    this.searchQuery = '';
    this.filteredEntries = this.extraction.entities;
  }

  flattenEntities(entities: any): string[] {
    const result: string[] = [];

    const traverse = (obj: any, parentKey: string = '') => {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          const fullKey = parentKey ? `${parentKey} > ${key}` : key;

          if (typeof value === 'object' && value !== null) {
            traverse(value, fullKey);
          } else {
            result.push(`${fullKey}: ${value}`);
          }
        }
      }
    };

    traverse(entities);
    return result;
  }

  downloadItems: MenuItem[] = [
    { label: 'Download as CSV', icon: 'pi pi-file-excel', command: () => this._extraction.downloadEntities(this.extraction.entities, this.extraction.filename, 'csv') },
    { label: 'Download as JSON', icon: 'pi pi-file', command: () => this._extraction.downloadEntities(this.extraction.entities, this.extraction.filename, 'json') },
  ];

  hasEntities(): boolean {
    const entities = this.extraction?.entities;
    return !!entities && typeof entities === 'object' && Object.keys(entities).length > 0;
  }

  isSaving: boolean = false;
  saveContract = () => {
    if (this.isSaving) return;
    let body = {
      entities: this.extraction.entities,
    };
    let param = {
      id: this.extraction._id,
    };
    this.isSaving = true;
    this._extraction.updateEntities(body, param).subscribe({
      next: (data: any) => {
        this._extraction.isEditEntities = false;
        this.isSaving = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Entities updated successfully',
          detail: 'Entities updated successfully',
          key: 'tr',
        });
      },
      error: (err) => {
        console.log(err);
        this.isSaving = false;
        this._extraction.isEditEntities = false;
        this.messageService.add({
          severity: 'warn',
          summary: 'Something went wrong',
          detail: 'Please try again later',
          key: 'tr',
        });
      },
    });
  };
}
